import actions from './actions';

const initialState = {
  data: [],
  url: null,
  fileLoading: false, 
  loading: false,
  error: null,
};

const initialStateSingle = {
  data: null,
  loading: false,
  error: null,
};

const partnersReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {

    case actions.PARTNER_ADD_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case actions.PARTNER_ADD_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case actions.PARTNER_ADD_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case actions.PARTNERS_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case actions.PARTNERS_READ_SUCCESS:
      return {
        ...state,
        data, 
        error: false,
        loading: false,
      };
    case actions.PARTNERS_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case actions.PARTNER_UPDATE_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case actions.PARTNER_UPDATE_SUCCESS:
      return {
        ...state,
        data, 
        error: false,
        loading: false,
      };
    case actions.PARTNER_UPDATE_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

const partnerReducer = (state = initialStateSingle, action) => {
  const { type, data, err } = action;
  switch (type) {
    case actions.PARTNER_READ_BEGIN:
      return {
        ...initialStateSingle,
        loading: true,
      };

    case actions.PARTNER_READ_SUCCESS:
      return {
        ...initialStateSingle,
        data,
        error: false,
        loading: false,
      };

    case actions.PARTNER_READ_ERR:
      return {
        ...initialStateSingle,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

export { partnersReducer, partnerReducer };
